module.exports = __webpack_public_path__ + "files/956ebbfbb301ac9cea4685971f536b39.png";